import { yupToFormErrors } from "formik"
import { I18n } from "utils/i18n-shim"
import client from "utils/client"

export const getValidationWithContext = (schema, context) => {
  return (values) =>
    schema.validate(values, { abortEarly: false, context }).catch((err) => {
      throw yupToFormErrors(err)
    })
}

export const getCreatableTagsProps = () => ({
  creatable: true,
  multiple: true,
  freeSolo: true,
  selectOnFocus: true,
  clearOnBlur: true,
  handleHomeEndKeys: true,
  options: [],
  filterOptions: (options, params) => {
    const { inputValue } = params

    if (inputValue === "") return []

    return [
      {
        id: inputValue,
        name: I18n.t("add-tag", { value: inputValue })
      }
    ]
  },
  getOptionLabel: (option) => option.name || option,
  isOptionEqualToValue: (option, value) => option === value
})

export const getRemoteAutocompleteCreatableTagsProps = (
  creatableOptionLabel = "name"
) => {
  return {
    multiple: true,
    freeSolo: true,
    selectOnFocus: true,
    clearOnBlur: true,
    handleHomeEndKeys: true,
    creatableOptionLabel,
    isOptionEqualToValue: (a, b) => {
      return (
        a?.[creatableOptionLabel] === b?.[creatableOptionLabel] ||
        a === b?.[creatableOptionLabel]
      )
    }
  }
}

export const asyncValidateEmailOnBlur = (formik, excludeId = null) => {
  const { values, setFormikState, setFieldError } = formik

  return {
    onBlur: () => {
      if (!values.email) return

      setFormikState((prev) => ({ ...prev, isValidating: true }))

      client
        .get("/v2/validations/email.json", {
          params: { email: values.email, exclude_id: excludeId }
        })
        .catch(() => {
          setFieldError("email", "email-already-taken")
        })
        .finally(() => {
          setFormikState((prev) => ({ ...prev, isValidating: false }))
        })
    }
  }
}

/**
 * @param {import("formik").FormikProps<any>['setFieldValue']} setFieldValue
 * @param {{ [s: string]: any; }} values
 */
export const setFormikValues = (setFieldValue, values) => {
  Object.entries(values).forEach(([field, value]) => {
    setFieldValue(field, value)
  })
}

export const getInitialStep = (values, validations) => {
  if (values?.draftId) {
    const invalidIndex = validations.findIndex((validation) => {
      try {
        validation.validateSync(values)
        return false
      } catch (error) {
        return true
      }
    })
    if (invalidIndex === -1) {
      return validations.length - 1
    }

    return invalidIndex
  }
  return 0
}

export const getTouchedFields = (values) => {
  const touched = {}

  Object.keys(values).forEach((key) => {
    if (typeof values[key] === "object" && values[key] !== null) {
      touched[key] = getTouchedFields(values[key])
    } else {
      touched[key] = true
    }
  })

  return touched
}
